import { render, staticRenderFns } from "./ProjectConfigTags.vue?vue&type=template&id=ed356590&scoped=true"
import script from "./ProjectConfigTags.vue?vue&type=script&lang=js"
export * from "./ProjectConfigTags.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfigTags.vue?vue&type=style&index=0&id=ed356590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed356590",
  null
  
)

export default component.exports